export default __webpack_public_path__ + "static/media/ex_img_07_1.ae267e5b.png";